/**
 * @generated SignedSource<<7568ea68290a1bccca26198a31fe991e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType$data = {
  readonly assignedTeams: ReadonlyArray<{
    readonly color: string | null;
    readonly icon: TeamIcon | null;
    readonly id: string;
    readonly name: string;
  }>;
  readonly color: string | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType";
};
export type EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType$key = {
  readonly " $data"?: EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleEditScheduleTypesAssignTeam_scheduleType",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "assignedTeams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeScheduleType",
  "abstractKey": null
};
})();

(node as any).hash = "1cd28087491763214d8c6a1b9335df5a";

export default node;
